define(function(require) {
    var DomUtil = require("cartovista").DomUtil;
    return {
        ID: "Provincial_4",
        THEMESETS_IDS: ["Provincial_4"],
        SOURCE: '<span style="margin-top:15px; float:right; font-size:10px;">Source : MEQ, SIP, DGPP, DGVI, DIS, Taux de diplomation et qualification par cohorte au secondaire - édition 2026.</span>',
        TOP_PANEL: {
            PRINT_OPTIONS: {"landscape": false, "scale": 0.8},
            DEFAULTS: {
                GRAPH_TYPE: "bar",
                GRAPH_DATA_ORIENTATION: "rows",
                PADDING: {"left": 25, "top": 15, "right": 5, "bottom": 40},
                //DATA_TYPES: {"Réseau public": "line", "Élèves ordinaires": "line"},
                HEIGHT_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").height() /2 - 60;
                    else return 315;
                },
                WIDTH_FN: function() { 
                    if (!DomUtil.isResponsiveUI()) return $(".cv-left-top-pane").width() /3 - 150;
                    else return $("#BbGraphs_topPanel_container").width() - 20;
                },
                X_DATA_NAMES: ["2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
                X_AXIS_LABEL: {"text": "Cohortes", "position": "outer-right"},
                Y_AXIS_LABEL: "%",
                Y_AXIS_MIN_VALUE: 20,
                Y_AXIS_MAX_VALUE: 100,
                Y_AXIS_PADDING: 0,
                Y_GRID: true,
                DATA_COLORS: {
                    "Total élèves HDAA": "#68CEBA",
                    "Élèves en difficulté": "#379F8F",
                    "Élèves handicapés": "#246B65",
                    "Élèves ordinaires": "#D56050",
                    "Réseau public": "#095797"
                },
                TOOLTIP_TITLE_FN: function(x, graph) { return "Cohorte de " + graph.categories()[x] + "-" + (parseInt(graph.categories()[x])+1); }
                //TOOLTIP_VALUE_FN: function(y, graph) { return y + "%";}
            },
            SLIDES: [
                {
                    TITLE: "Taux de diplomation et qualification par cohorte au secondaire des élèves HDAA, au réseau public",
                    SUBTILE: null,
                    GRAPHS: [
                        {
                            TITLE: "Après 5 ans, sexes réunis",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_5_T_2007", "TX_5_T_2008", "TX_5_T_2009", "TX_5_T_2010", "TX_5_T_2011", "TX_5_T_2012", "TX_5_T_2013", "TX_5_T_2014", "TX_5_T_2015", "TX_5_T_2016", "TX_5_T_2017", "TX_5_T_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 5 ans, sexe masculin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_5_M_2007", "TX_5_M_2008", "TX_5_M_2009", "TX_5_M_2010", "TX_5_M_2011", "TX_5_M_2012", "TX_5_M_2013", "TX_5_M_2014", "TX_5_M_2015", "TX_5_M_2016", "TX_5_M_2017", "TX_5_M_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 5 ans, sexe féminin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_5_F_2007", "TX_5_F_2008", "TX_5_F_2009", "TX_5_F_2010", "TX_5_F_2011", "TX_5_F_2012", "TX_5_F_2013", "TX_5_F_2014", "TX_5_F_2015", "TX_5_F_2016", "TX_5_F_2017", "TX_5_F_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexes réunis",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_7_T_2007", "TX_7_T_2008", "TX_7_T_2009", "TX_7_T_2010", "TX_7_T_2011", "TX_7_T_2012", "TX_7_T_2013", "TX_7_T_2014", "TX_7_T_2015", "TX_7_T_2016", "TX_7_T_2017", "TX_7_T_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexe masculin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_7_M_2007", "TX_7_M_2008", "TX_7_M_2009", "TX_7_M_2010", "TX_7_M_2011", "TX_7_M_2012", "TX_7_M_2013", "TX_7_M_2014", "TX_7_M_2015", "TX_7_M_2016", "TX_7_M_2017", "TX_7_M_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }, {
                            TITLE: "Après 7 ans, sexe féminin",
                            DATA_SOURCES: [
                                {
                                    LAYER_ID: "ThematiqueProv_EHDAA",
                                    DATATABLE_ID: "t_frequentation",
                                    FEATURES_IDS: ["STATUT_REG", "STATUT_TOUT", "STATUT_HDAA", "STATUT_DIFF", "STATUT_HAND"],
                                    DATACOLUMNS_IDS: ["TX_7_F_2007", "TX_7_F_2008", "TX_7_F_2009", "TX_7_F_2010", "TX_7_F_2011", "TX_7_F_2012", "TX_7_F_2013", "TX_7_F_2014", "TX_7_F_2015", "TX_7_F_2016", "TX_7_F_2017", "TX_7_F_2018"],
                                    NO_SELECTION_SHOW_ALL_FEATURES: true
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
